<script setup>
import Layout from "@/Shared/Layout";
import {ref} from "vue";
import CreateUser from "@/Shared/CreateUser";
const showCreate = ref(false)


const close = () => {
    showCreate.value = false
}
const createNew = (value) => {
    role.value = value;
    showCreate.value = true
}

const role = ref("elo")

const submit = async (params) => {
    console.log(params);
}
</script>
<template>
    <Layout main="Users" sub="users">
        <div class="flex justify-center item-center py-12">
            <button
                @click="createNew"
                type="button"
                class="relative block w-1/2  bg-white  border-[1px] border-gray-300 border-solid rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto h-12 w-12 text-gray-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                    />
                </svg>

                <span class="mt-2 block text-sm font-medium text-gray-900">
                    Create a new user
                </span>
            </button>
        </div>
        <CreateUser role="elo" @submit="submit" @close="close()" :show="showCreate"/>
    </Layout>
</template>
